document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.previews__questions-tab-button');

    if (buttons.length) {
        const first = buttons[0];
        const firstTarget = document.getElementById(first.dataset.toggle);
        const firstIcon = first.querySelector('.icon-toggle');
        if (firstTarget) {
            firstTarget.classList.add('show');
            firstTarget.style.height = firstTarget.scrollHeight + 'px';
            if (firstIcon) {
                firstIcon.style.transform = 'rotate(180deg)';
                firstIcon.textContent = '-';
            }
        }
    }

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            const target = document.getElementById(button.dataset.toggle);
            if (!target) return;
            const isOpen = target.classList.contains('show');

            buttons.forEach(btn => {
                const t = document.getElementById(btn.dataset.toggle);
                const icon = btn.querySelector('.icon-toggle');
                if (t && t !== target && t.classList.contains('show')) {
                    t.style.height = t.scrollHeight + 'px';
                    requestAnimationFrame(() => t.style.height = '0');
                    t.addEventListener('transitionend', () => t.classList.remove('show'), { once: true });
                    if (icon) {
                        icon.style.transform = 'rotate(0deg)';
                        icon.textContent = '+';
                    }
                }
            });

            const icon = button.querySelector('.icon-toggle');
            if (isOpen) {
                target.style.height = target.scrollHeight + 'px';
                requestAnimationFrame(() => target.style.height = '0');
                target.addEventListener('transitionend', () => target.classList.remove('show'), { once: true });
                if (icon) {
                    icon.style.transform = 'rotate(0deg)';
                    icon.textContent = '+';
                }
            } else {
                target.classList.add('show');
                target.style.height = target.scrollHeight + 'px';
                if (icon) {
                    icon.style.transform = 'rotate(180deg)';
                    icon.textContent = '-';
                }
            }
        });
    });
});